var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{staticClass:"presence-badge",attrs:{"color":_vm.online ? _vm.onlineColor : 'rgba(120, 111, 96, 0.12)',"text-color":_vm.online ? 'white' : '#7a6f60',"small":""}},[_c('span',{staticClass:"presence-dot",class:{ 'presence-dot--online': _vm.online }}),_vm._v(" "+_vm._s(_vm.label)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }